import React from 'react';
import Const from './Const';
import { DropDown } from '../../../common/dropdown';
import { connect } from 'react-redux';
import { changeComGroupCode, REDUCER_NAME } from './reducer';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from './../../../app/commonReducer';

class DropDownCode extends React.Component {
  render() {
    const {
      listIcbCodeIndustry,
      listIndustryByIcbCode,
      comGroupCode,
      changeComGroupCode,
    } = this.props;

    return (
      <DropDown
        keyTitle={Const.listColumnIndustry.ICB_NAME}
        listKey={[...Const.listComGroupCode, ...listIcbCodeIndustry]}
        listDataByKey={{
          ...Const.listComGroupCodeByKey,
          ...listIndustryByIcbCode,
        }}
        currentKey={comGroupCode}
        change={changeComGroupCode}
        isEditable={false}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    comGroupCode: state[REDUCER_NAME].comGroupCode,
    listIcbCodeIndustry: state[COMMON_REDUCER_NAME].listIcbCodeIndustry,
    listIndustryByIcbCode: state[COMMON_REDUCER_NAME].listIndustryByIcbCode,
  };
};

const mapDispatchToProps = {
  changeComGroupCode,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DropDownCode);
